import styled from "styled-components"
import { themeGet } from "@styled-system/theme-get"

const NewsletterWrapper = styled.div`
  position: relative;
  margin-top: -210px;
  padding: 0px 30px;

  @media (max-width: 1220px) {
    padding: 0px 30px;
    margin-top: -160px;
  }
  @media (max-width: 990px) {
    padding: 0px 30px;
    margin-top: -230px;
  }
  @media (max-width: 575px) {
    padding: 0px 30px;
  }

  .container {
    background-color: ${themeGet("colors.mainBlue")};
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 70px 80px 80px;
    @media only screen and (max-width: 480px) {
      padding: 30px 30px 30px;
    }
    h2 {
      margin-top: 0px;
      margin-bottom: 0px;
      @media (max-width: 990px) {
        margin-top: 0px;
      }
    }
    @media only screen and (max-width: 1220px) {
      padding: 100px 120px;
    }
    @media (max-width: 990px) {
      flex-wrap: wrap;
      justify-content: center;
      padding: 80px 80px;
    }
    @media only screen and (max-width: 480px) {
      padding: 30px 30px;
    }
  }
`

export const NewsletterFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 520px;
  max-width: 100%;
  margin-left: auto;
  margin-right: 0px;
  @media (max-width: 990px) {
    width: 100%;
  }
  @media (max-width: 575px) {
    width: 100%;
  }
  @media (max-width: 575px) {
    flex-direction: column;
    align-items: center;
    margin-bottom: 25px;
  }

  .reusecore__button {
    background-color: ${themeGet("colors.white")};
    color: ${themeGet("colors.mainBlue")};
    font-size: 20px;
    border-radius: 0px;
    padding: 20px 21px;
    text-transform: capitalize;
    margin-top: 30px;
    width: 100%;
    &:hover {
      background-color: ${themeGet("colors.whiteHover")};
    }
  }
`

export default NewsletterWrapper
